import { createAction } from '@reduxjs/toolkit';
import { IClientMessage } from 'src/interfaces';

export const resetReducer = createAction('reset');

export const popMessageStack = createAction<IClientMessage>('popMessageStack');
